import { motion } from 'framer-motion'
import * as React from 'react'
import styled from 'styled-components'

interface IStyle {
    width?: string | undefined
    height?: string | undefined
    bordercolor?: string
    textcolor?: string
    transparent?: boolean
    isdisabled?: boolean
    disabledcolor?: string
}

const Button = styled(motion.div)<IStyle>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${(props) => (props.width ? props.width : '160px')};
    height: ${(props) => (props.height ? props.height : '32px')};
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    padding-right: 20px;
    border: ${(props) =>
        props.bordercolor
            ? `1px solid ${props.bordercolor}`
            : '1px solid #00A9AF'};
    outline: none;
    background-color: ${(props) =>
        props.transparent ? 'transparent' : 'white'};
    border-radius: 5px;
    transition: all 200ms;
    cursor: pointer;
    :hover {
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.09);
        transition: all 200ms;
    }
    :focus {
        background-color: none;
    }
`

const Text = styled.div<IStyle>`
    color: ${(props) =>
        props.textcolor
            ? props.textcolor
            : props.isdisabled
            ? props.disabledcolor
                ? props.disabledcolor
                : '#ADADAD'
            : '#00A9AF'};
    font-family: 'Lato';
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 1px;
`

type Props = {
    onClick: any
    text: string | undefined
    dataAttId?: string | undefined
    width?: string | undefined
    height?: string | undefined
    isdisabled?: boolean
    bordercolor?: string
    textcolor?: string
    transparent?: boolean
    disabledcolor?: string
}

const SolidBorderWhiteBgButton: React.FunctionComponent<Props> = (props) => {
    let {
        onClick,
        text,
        width,
        height,
        transparent,
        bordercolor,
        textcolor,
        isdisabled,
        disabledcolor,
        dataAttId,
    } = props
    return (
        <Button
            width={width}
            height={height}
            onClick={onClick}
            data-attr={dataAttId ? dataAttId : undefined}
            bordercolor={bordercolor}
            transparent={transparent}
            whileTap={{ scale: 1.1 }}
        >
            <Text
                textcolor={textcolor}
                isdisabled={isdisabled}
                disabledcolor={disabledcolor}
            >
                {text}
            </Text>
        </Button>
    )
}

export default SolidBorderWhiteBgButton
